<template>
  <div class="auth-page d-flex justify-content-center align-items-center py-4">
    <form class="auth-card shadow-lg p-4 p-md-5" @submit.prevent="handleSubmit">
      <div class="text-center mb-4">
        <h1 class="h5 fw-semibold mb-1">Сброс пароля</h1>
        <p class="text-muted small mb-0">Укажите e-mail — мы отправим ссылку для нового пароля.</p>
      </div>
      <div class="mb-3">
        <EmailInput v-model="email" class="form-control" placeholder="name@example.com" required />
      </div>
      <div v-if="message" class="alert alert-success py-2 small">{{ message }}</div>
      <div v-if="errorMsg" class="alert alert-danger py-2 small">{{ errorMsg }}</div>
      <button class="btn btn-primary w-100" :disabled="loading">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2" />
        Отправить
      </button>
      <p class="text-center small text-muted mt-3 mb-0">
        <router-link to="/login">Вернуться ко входу</router-link>
      </p>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/api'
import EmailInput from '@/components/form/EmailInput.vue'
import { normalizeEmail } from '@/utils/emailInput'

const email = ref('')
const loading = ref(false)
const message = ref('')
const errorMsg = ref('')

async function handleSubmit() {
  errorMsg.value = ''
  message.value = ''
  loading.value = true
  try {
    const { data } = await api.post('/auth/password-reset/', { email: normalizeEmail(email.value) })
    message.value = data?.detail || 'Если аккаунт существует, мы отправили инструкции на почту.'
  } catch (e) {
    errorMsg.value = e?.response?.data?.detail || 'Не удалось отправить запрос. Попробуйте позже.'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  padding: 1.5rem;
}
.auth-card {
  width: 100%;
  max-width: 480px;
  border-radius: 1rem;
  background: #fff;
}
</style>
